var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "h1",
        { staticStyle: { "margin-bottom": "10px", "font-size": "18px" } },
        [_vm._v("新用户明细")]
      ),
      _c(
        "el-form",
        { ref: "form", attrs: { "label-width": "80px" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { margin: "10px 0" } },
                  [
                    _c(
                      "el-form-item",
                      { ref: "form", attrs: { label: "选择油站" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择"
                            },
                            model: {
                              value: _vm.formatDate.stationId,
                              callback: function($$v) {
                                _vm.$set(_vm.formatDate, "stationId", $$v)
                              },
                              expression: "formatDate.stationId"
                            }
                          },
                          _vm._l(_vm.stationOptions, function(item) {
                            return _c("el-option", {
                              key: item.ID,
                              attrs: { label: item.stationName, value: item.ID }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { margin: "10px 0" } },
                  [
                    _c(
                      "el-form-item",
                      { ref: "form", attrs: { label: "数据类型" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: "请选择"
                            },
                            model: {
                              value: _vm.formatDate.dataType,
                              callback: function($$v) {
                                _vm.$set(_vm.formatDate, "dataType", $$v)
                              },
                              expression: "formatDate.dataType"
                            }
                          },
                          _vm._l(_vm.dataTypes, function(item) {
                            return _c("el-option", {
                              key: item.ID,
                              attrs: { label: item.Name, value: item.ID }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { margin: "10px 0" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "开始时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "选择日期时间",
                            "picker-options": _vm.pickerOptionsStart
                          },
                          model: {
                            value: _vm.formatDate.startTime,
                            callback: function($$v) {
                              _vm.$set(_vm.formatDate, "startTime", $$v)
                            },
                            expression: "formatDate.startTime"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { margin: "10px 0" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "结束时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "选择日期时间",
                            "picker-options": _vm.pickerOptions,
                            "default-time": "23:59:59",
                            disabled: !_vm.formatDate.startTime
                          },
                          model: {
                            value: _vm.formatDate.endTime,
                            callback: function($$v) {
                              _vm.$set(_vm.formatDate, "endTime", $$v)
                            },
                            expression: "formatDate.endTime"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
        [_vm._v("提交下载任务")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }